import { Skeleton } from "antd";
import { IWorkHistory } from "features/settings/types";
import React from "react";

const parseAchievements = (raw: any): string[] => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const WorkHistory: React.FC<{
  data: IWorkHistory[];
  volunteer: IWorkHistory[];
  isLoading?: boolean;
}> = ({ data, volunteer, isLoading }) => {
  const formatDate = (date: string | null) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toLocaleDateString("en-GB", {
      month: "short",
      year: "numeric",
    });
  };

  const renderCard = (item: IWorkHistory) => {
    const achievements = parseAchievements((item as any).achievements);

    return (
      <div className="bg-white border border-gray-200 rounded-xl p-5 mb-4">
        <span className="text-sm font-semibold text-primary">
          {item.company}
        </span>

        <h4 className="text-base font-medium text-primary pt-1">
          {item.title}
        </h4>

        <p className="text-xs text-gray-500 pt-1">
          {formatDate(item.start_date)} –{" "}
          {item.is_current === 1 ? "Present" : formatDate(item.end_date)}
        </p>

        {item.description && (
          <p className="mt-3 text-sm text-gray-600 leading-relaxed">
            {item.description}
          </p>
        )}

        {achievements.length > 0 && (
          <>
            <h4 className="mt-4 text-sm font-semibold text-gray-800">
              Achievements
            </h4>
            <ul className="mt-2 list-disc list-inside space-y-1 text-sm text-gray-600">
              {achievements.map((line, idx) => (
                <li key={idx}>{line}</li>
              ))}
            </ul>
          </>
        )}
      </div>
    );
  };

  return (
    <>
      <h3 className="font-semibold text-base text-gray-800 mb-4">
        Work Experience
      </h3>

      <Skeleton active loading={isLoading}>
        <div className="space-y-4">
          {data.length > 0 ? (
            data.map((item) => <div key={item.id}>{renderCard(item)}</div>)
          ) : (
            <p className="text-sm text-gray-500">No work experience added.</p>
          )}
        </div>
      </Skeleton>

      {volunteer.length > 0 && (
        <>
          <h3 className="font-semibold text-base text-gray-800 mt-8 mb-4">
            Volunteer Experience
          </h3>

          <Skeleton active loading={isLoading}>
            <div className="space-y-4">
              {volunteer.map((item) => (
                <div key={item.id}>{renderCard(item)}</div>
              ))}
            </div>
          </Skeleton>
        </>
      )}
    </>
  );
};
